import { events } from "@constants/tracking";
import useAnalytics from "@hooks/useAnalytics";
import type { ProductType } from "@memorang/types";
import { DialogWrapper } from "@memorang/ui";
/* -----------------UI--------------- */
import { Dialog as PaperDialog } from "react-native-paper";
import PurchaseContainer from "./PurchaseContainer";

type Props = {
	visible: boolean;
	handleClose: () => void;
	productType?: ProductType;
	fromHomePage?: boolean;
};
export const PurchaseDialog = ({
	visible,
	handleClose,
	productType,
	fromHomePage,
}: Props) => {
	const { explicitCallTrackCustomEvent } = useAnalytics();
	const getTitle = () => {
		switch (productType) {
			case "STUDY_PACK":
				return "Upgrade your study plan";
			case "PRACTICE_TEST":
				return "Unlock practice tests";
			default:
				return "Upgrade";
		}
	};
	const title = getTitle();

	const handleDialogClose = () => {
		handleClose();
		explicitCallTrackCustomEvent({
			eventName: events.paywallClosed,
		});
	};
	return (
		<DialogWrapper visible={visible} handleClose={handleDialogClose}>
			<PaperDialog.Title style={{ textAlign: "center" }}>
				{title}
			</PaperDialog.Title>
			<PurchaseContainer
				handleClose={handleDialogClose}
				productType={productType}
				fromHomePage={fromHomePage}
			/>
		</DialogWrapper>
	);
};
